import {INoticeService, NoticeService} from "./noticeService";
import {IVillageService, VillageService} from "./villageService";
import {BackendCaller} from "./backendCaller";
import {AccountService, IAccountService} from "./accountService";
import {EventService, IEventService} from "./eventService";
import {
  PrintableCalendarService,
  IPrintableCalenderService
} from "./printableCalendarService";
import {FileService, IFileService} from "./fileService";
import {
  IResidentAdminService,
  ResidentAdminService
} from "./residentAdminService";
import EventCatalogueService, {
  IEventCatalogueService
} from "./eventCatalogueService";
import {
  IVillageScheduleService,
  VillageScheduleService
} from "./villageScheduleService";
import {ITransactionService, TransactionService} from "./transactionService";
import {IOccasionService, OccasionService} from "./occasionService";
import {
  IVillageCalendarService,
  VillageCalendarService
} from "./villageCalendarService";
import {IPersonTypeService, PersonTypeService} from "./personTypeService";

export interface ITransportServices {
  noticeService: INoticeService;
  eventService: IEventService;
  printableCalendarService: IPrintableCalenderService;
  residentAdminService: IResidentAdminService;
  villageService: IVillageService;
  accountService: IAccountService;
  fileService: IFileService;
  eventCatalogueService: IEventCatalogueService;
  villageScheduleService: IVillageScheduleService;
  processedBookingService: ITransactionService;
  occasionService: IOccasionService;
  villageCalendarService: IVillageCalendarService;
  personTypeService: IPersonTypeService;
}

export class TransportServices implements ITransportServices {
  noticeService: INoticeService;
  eventService: IEventService;
  printableCalendarService: IPrintableCalenderService;
  residentAdminService: IResidentAdminService;
  villageService: IVillageService;
  fileService: IFileService;
  accountService: IAccountService;
  eventCatalogueService: IEventCatalogueService;
  villageScheduleService: IVillageScheduleService;
  processedBookingService: ITransactionService;
  occasionService: IOccasionService;
  villageCalendarService: IVillageCalendarService;
  personTypeService: IPersonTypeService;

  constructor() {
    let backendCaller = new BackendCaller();
    this.noticeService = new NoticeService(backendCaller);
    this.eventService = new EventService(backendCaller);
    this.printableCalendarService = new PrintableCalendarService(backendCaller);
    this.residentAdminService = new ResidentAdminService(backendCaller);
    this.villageService = new VillageService(backendCaller);
    this.fileService = new FileService(backendCaller);
    this.accountService = new AccountService();
    this.eventCatalogueService = new EventCatalogueService(backendCaller);
    this.villageScheduleService = new VillageScheduleService(backendCaller);
    this.processedBookingService = new TransactionService(backendCaller);
    this.occasionService = new OccasionService(backendCaller);
    this.villageCalendarService = new VillageCalendarService(backendCaller);
    this.personTypeService = new PersonTypeService(backendCaller);
  }
}
